import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
// import styled from 'styled-components';

function InxToolTip(props) {
    const {
        type='light',
        styles = {maxWidth: '250px', borderColor: 'var(--color-black)'},
        ...rest
    } = props;

    return <ReactTooltip
        border borderColor={'var(--color-black)'}
        effect='solid'
        style={styles || null}
        type={type}
        {...rest}
    />;
}

InxToolTip.propTypes = {
    id: PropTypes.string,
    styles: PropTypes.object,
    type: PropTypes.string
};

export default InxToolTip;
